import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { MoonIcon, SunIcon } from 'lucide-react';
const ThemeToggle: React.FC = () => {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`} data-id="element-251">
      {theme === 'light' ? <MoonIcon className="w-5 h-5 text-gray-700" data-id="element-252" /> : <SunIcon className="w-5 h-5 text-yellow-300" data-id="element-253" />}
    </button>;
};
export default ThemeToggle;